import * as Yup from "yup";

export const getInitialValues = () => {
  return {
    name: "",
    email: "",
    phone: "",
    date_1: "",
    time_1: "",
    date_2: "",
    time_2: "",
    date_3: "",
    time_3: "",
  };
};

export const validationSchema = Yup.object({
  name: Yup.string()
    .trim("Business Name should not contain spaces")
    .required("Business Name is required"),
  date_1: Yup.string()
    .trim("Date should not contain spaces")
    .required("Date is required"),
  time_1: Yup.string()
    .trim("Time should not contain spaces")
    .required("Time is required"),

  phone: Yup.string()
    .trim()
    .test("phone", "Phone number must contain only numeric digits", (value) => {
      if (!value) {
        // Allow empty values, assuming they are valid
        return true;
      }
      return /^[0-9()-]+$/.test(value);
    })
    .matches(/^[0-9()-]+$/, "Invalid phone number format")
    .required("Phone number is required"),
  email: Yup.string()
    .trim("Business should not contain spaces")
    .email("Invalid email address")
    .required("Business email is required"),
});
